import { makeStyles } from '@material-ui/core';
import { hSpacing } from 'src/common/helpers/config';
import { themeColor } from 'src/mui-theme';

interface saleScreenProps {
  secondaryColor: string;
}

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => ({
  root: {
    flexBasis: 0,
  },
  bottomArea: {
    flex: '1 1 auto',
    padding: '0.75vw',
  },
  checkoutContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 44.75vw',
    marginRight: '0.75vw',
    width: 'auto',
    height: 'auto',
    paddingTop: `0 !important`,
  },
  imageContainer: {
    border: `1px solid ${themeColor.lightgrey}`,
    flex: '1 1 53vw',
    width: 'auto',
    height: 'auto',
    padding: '0.3vw',
  },
  trainingImageContainer: {
    backgroundColor: `${themeColor.trainingBackground}!important`,
  },
  image: {
    width: '100%',
    height: '100%',
  },
  itemListContainer: {
    marginRight: 0,
    marginLeft: 0,
  },
  logo: {
    position: 'absolute',
    left: '1%',
    height: '8vh',
  },
  ntep: {
    position: 'absolute',
    right: '0',
    bottom: '70%',
    transform: 'rotate(-90deg)',
    transformOrigin: '100% 100%',
    fontSize: '1.22vh',
    fontWeight: 500,
    letterSpacing: '.0625rem',
    color: theme.ntepText,
  },
  scale: {
    marginLeft: '20vw',
    paddingTop: '1.8vh',
  },
  topAdvert: {
    flex: 1,
    padding: '0 1.756vw',
    overflow: 'hidden',
    zIndex: 10,
  },
  trainingWaterMark: {
    position: 'absolute',
    width: '100%',
    height: '11.4583vh',
    left: '20vw',
    top: '17%',
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '5.5rem',
    lineHeight: '100px',
    alignItems: 'center',
    textAlign: 'center',
    color: themeColor.watermark,
    mixBlendMode: 'normal',
    transform: 'rotate(-20deg)',
    '@media (max-height: 900px)': {
      fontSize: '4.5rem',
    },
    '@media (max-height: 768px)': {
      fontSize: '3.9rem',
    },
    '@media (max-height: 720px)': {
      fontSize: '3.5rem',
    },
    '@media (max-height: 576px)': {
      fontSize: '2.8rem',
    },
    '@media (aspect-ratio: 4/3)': {
      '@media (max-height: 1200px)': {
        fontSize: '3.9rem',
      },
      '@media (max-height: 768px)': {
        fontSize: '2.8rem',
      },
    },
  },

  trainingModeBackground: {
    backgroundColor: `${themeColor.trainingBackground}!important`,
  },
  topAreaContainer: {
    padding: '0',
    height: '8vh',
    paddingRight: hSpacing,
    borderColor: ({ secondaryColor }: saleScreenProps) =>
      secondaryColor ? secondaryColor : theme.secondaryContrast,
    borderLeft: `${hSpacing} solid`,
  },
  adDisplay: {
    flex: '1',
  },
  customerContainer: {
    flex: '2',
    flexDirection: 'column',
  },
  adImage: {
    contain: 'size',
    height: '100%',
    width: '100%',
  },
  divider: {
    height: '.835vh',
  },
  topAreaContainerTraining: {
    borderLeft: `${hSpacing} solid ${themeColor.watermarkblue}`,
  },
}));
